import { render, staticRenderFns } from "./CreatePool.vue?vue&type=template&id=287a3b49&"
import script from "./CreatePool.vue?vue&type=script&lang=js&"
export * from "./CreatePool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports